module.exports = __webpack_public_path__ + "static/gormanet-logo-716553f50c952127bbe64eed8ea30925.png";